import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/api';

export default function SignOutButton() {
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);

  async function handleSignOut() {
    if (signingOut) return;
    setSigningOut(true);
    // The server call revokes the refresh token cookie. We always sign out
    // locally afterwards even if the network call fails — the access token
    // is short-lived and we'd rather drop the user back to the login screen
    // than strand them on a screen they no longer trust.
    try { await logout(); } catch { /* swallow — sign out locally anyway */ }
    localStorage.clear();
    navigate('/parent/login');
  }

  return (
    <button
      type="button"
      onClick={handleSignOut}
      disabled={signingOut}
      style={{
        background: 'transparent',
        border: '1px solid #E2E8F0',
        color: '#64748B',
        padding: '7px 14px',
        borderRadius: 8,
        fontFamily: 'inherit',
        fontSize: 13,
        fontWeight: 600,
        cursor: signingOut ? 'default' : 'pointer',
        transition: 'border-color 160ms ease, color 160ms ease, background 160ms ease',
      }}
      onMouseEnter={(e) => {
        if (signingOut) return;
        e.currentTarget.style.borderColor = '#CBD5E1';
        e.currentTarget.style.color = '#1E293B';
        e.currentTarget.style.background = '#F8FAFC';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = '#E2E8F0';
        e.currentTarget.style.color = '#64748B';
        e.currentTarget.style.background = 'transparent';
      }}
    >
      {signingOut ? 'Signing out…' : 'Sign out'}
    </button>
  );
}
